import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DOCUMENT } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

/**
 * Aviso a pantalla completa para un dominio que pertenece a un nivel de marcas
 * pero no está asignado a ninguna — típicamente uno recién dado de baja que el
 * navegador todavía resuelve por su caché de DNS.
 *
 * **Identidad NEUTRA a propósito (R5).** Sin logo, sin `appName` y sin un solo
 * token de color de MARCA: en este estado no hay marca válida que representar, y
 * pintar la de la plataforma es justamente lo que este aviso viene a evitar —
 * sería volver a hacer pasar el dominio por la marca base. Solo se usan los
 * tokens SEMÁNTICOS (texto, grises, superficie), que no se tiñen por tenant.
 *
 * **No revela el inquilinato (R6).** No nombra marcas ni sugiere hostnames: este
 * aviso lo puede abrir cualquiera, y enumerar clientes ahí sería una fuga.
 * Tampoco lleva enlaces a la aplicación — no hay adónde ir desde un dominio que
 * no es de nadie.
 */
@Component({
  selector: 'app-unassigned-domain-notice',
  standalone: true,
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './unassigned-domain-notice.component.html',
  styleUrl: './unassigned-domain-notice.component.scss',
})
export class UnassignedDomainNoticeComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  private readonly documento = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  /**
   * La PESTAÑA también es marca. Sin esto el título se quedaba en el `appName`
   * del tema base, así que el dominio no asignado se seguía presentando como la
   * marca base justo donde más se ve — el defecto que la pantalla corrige.
   *
   * Va por `selectTranslate` y no por `translate` porque el aviso se monta en el
   * arranque, cuando el idioma puede no estar cargado todavía: `translate`
   * devolvería la LLAVE y eso es lo que quedaría en la pestaña.
   */
  ngOnInit(): void {
    this.transloco
      .selectTranslate('tenant.unassignedDomain.title')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((titulo: string) => {
        this.documento.title = titulo;
      });
  }
}
